<template>
  <div id="zoom-btn">
    <button
      class="mdn-Menu-top-event mdn-Modal--handler"
      title="Modal Zoom texto"
      @click.prevent="$emit('openModal')"
    >
      <span
        class="mdn-Icon-diminuir-tamanho mdn-Icon--sm mdn-Menu-text-icon"
        aria-hidden="true"
      ></span>
      <span
        class="mdn-Icon-aumentar-tamanho mdn-Icon--sm mdn-Menu-text-icon"
        aria-hidden="true"
      ></span>
    </button>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  name: "ZoomButton",
})
export default class ZoomButton extends Vue {}
</script>

<style lang="scss" scoped></style>
